import { Routes } from '@angular/router';
import { authGuard } from './guard/auth.guard';
import { PRIVACY, TAGS_CONSUME_LOCAL, TERMS } from '@shared/seo.tags';

export const routes: Routes = [
    {
        path: 'nosotros',
        loadChildren: () => import('./about/about.routes').then(r => r.aboutRoutes)
    },
    {
        path: 'autenticacion',
        loadChildren: () => import('./auth/auth.routes').then(r => r.authRoutes)
    },
    // TODO Migrate routes
    {
        path: 'carrito',
        loadChildren: () => import('src/app/cart/cart.module').then(m => m.CartModule),
        canActivate: [authGuard],
        canMatch: [authGuard]
    },
    {
        path: 'club-alsuper',
        loadChildren: () => import('src/app/club/club.module').then(m => m.ClubModule)
    },
    {
        path: 'departamento',
        loadChildren: () => import('src/app/department/department.module').then(m => m.DepartmentModule)
    },
    {
        path: 'filtros',
        loadChildren: () => import('src/app/filter/filter.module').then(m => m.FilterModule)
    },
    {
        path: 'ayuda',
        loadChildren: () => import('src/app/help/help.module').then(m => m.HelpModule)
    },
    {
        path: '',
        loadChildren: () => import('./home/home.routes').then(r => r.homeRoutes)
    },
    {
        path: 'producto/:id',
        loadChildren: () => import('src/app/product/product.module').then(m => m.ProductModule),
    },
    {
        path: 'perfil',
        loadChildren: () => import('src/app/profile/profile.module').then(m => m.ProfileModule),
        canActivate: [authGuard],
        canMatch: [authGuard]
    },
    {
        path: 'carrusel/:nombre',
        loadChildren: () => import('src/app/carousel/carousel.module').then(m => m.CarouselModule)
    },
    {
        path: 'ofertas',
        loadChildren: () => import('src/app/offers/offers.module').then(m => m.OffersModule)
    },
    {
        path: 'paypal',
        loadChildren: () => import('src/app/paypal/paypal.module').then(m => m.PaypalModule)
    },
    {
        path: 'compra-en-proceso',
        loadChildren: () => import('src/app/purchase/purchase.module').then(m => m.PurchaseModule),
        canActivate: [authGuard],
        canMatch: [authGuard]
    },
    {
        path: 'seguimiento/:id',
        loadChildren: () => import('src/app/tracking/tracking.module').then(m => m.TrackingModule),
        canActivate: [authGuard],
        canMatch: [authGuard]
    },
    {
        path: 'al-asador',
        loadChildren: () => import('src/app/grilled/grilled.module').then(m => m.GrilledModule)
    },
    {
        path: 'listas-alsuper',
        loadChildren: () => import('src/app/alsuper-lists/alsuper-lists.module').then(m => m.AlsuperListsModule),
        canActivate: [authGuard],
        canMatch: [authGuard]
    },
    {
        path: 'recetas',
        loadChildren: () => import('src/app/recipes/recipes.module').then(m => m.RecipesModule)
    },
    {
        path: 'activar',
        loadChildren: () => import('src/app/club-alsuper-form/club-alsuper-form.module').then(m => m.ClubAlsuperFormModule)
    },
    {
        path: 'proveedor',
        loadChildren: () => import('src/app/suppliers/suppliers.module').then(m => m.SuppliersModule)
    },
    {
        path: 'recomendaciones',
        loadChildren: () => import('src/app/recommendations/recommendations.module').then(m => m.RecommendationsModule),
        canActivate: [authGuard],
        canMatch: [authGuard]
    },
    // TODO Migrate routes
    {
        path: 'webview-help',
        loadComponent: () => import('./webview-help/webview-help.component').then(c => c.WebviewHelpComponent)
    },
    {
        path: 'webview-tyc',
        loadComponent: () => import('./webview-tyc/webview-tyc.component').then(c => c.WebviewTycComponent),
        title: TERMS.title,
        data: { description: TERMS.description }
    },
    {
        path: 'webview-aviso',
        loadComponent: () => import('./webview-aviso/webview-aviso.component').then(c => c.WebviewAvisoComponent),
        title: PRIVACY.title,
        data: { description: PRIVACY.description }
    },
    {
        path: 'tiendas',
        loadComponent: () => import('./stores/stores.component').then(c => c.StoresComponent)
    },
    {
        path: 'cuenta-eliminada',
        loadComponent: () => import('./account-deletion-confirmation/account-deletion-confirmation.component').then(c => c.AccountDeletionConfirmationComponent)
    },
    {
        path: 'facturacion',
        loadComponent: () => import('./billing/billing.component').then(c => c.BillingComponent)
    },
    {
        path: 'healthy-circle',
        loadComponent: () => import('./healthy-circle/healthy-circle.component').then(c => c.HealthyCircleComponent)
    },
    {
        path: 'consume-local',
        loadComponent: () => import('./consume-local/consume-local.component').then(c => c.ConsumeLocalComponent),
        title: TAGS_CONSUME_LOCAL.title,
        data: { description: TAGS_CONSUME_LOCAL.description }
    },
    {
        path: 'alsuper-card',
        loadComponent: () => import('./footer-alsuper-card/footer-alsuper-card.component').then(c => c.FooterAlsuperCardComponent)
    },
    {
        path: 'pagos/approve',
        loadComponent: () => import('./shared/components/payments-approve/payments-approve.component').then(c => c.PaymentsApproveComponent)
    },
    {
        path: 'alsuperapp',
        loadComponent: () => import('./shared/components/landing-download-apps/landing-download-apps.component').then(c => c.LandingDownloadAppsComponent)
    },
    {
        path: '',
        redirectTo: '',
        pathMatch: 'full'
    },
    {
        path: '**',
        redirectTo: ''
    }
];
